export const SCRAPREASONSMAPPING = {
    'Atoramiento en feeder (100)': {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en feeder (100)",
        other_comment: null
    },
    'Atoramiento en unidad de corte (101)': {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en unidad de corte (101)",
        other_comment: null
    },
    'Atoramiento en stacker (102)': {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en stacker (102)",
        other_comment: null
    },
    'Descentrado (103)': {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Descentrado",
        reason: "Descentrado (103)",
        other_comment: null
    },
    'Dado no corta (104)': {
        location: "Horizon",
        category: "Metodologia",
        problem: "Herramental",
        reason: "Dado no corta (104)",
        other_comment: null
    },
    'Dado equivocado (105)': {
        location: "Horizon",
        category: "Metodologia",
        problem: "Herramental",
        reason: "Dado equivocado (105)",
        other_comment: null
    },
    'Dado realiza corte profundo (106)': {
        location: "Horizon",
        category: "Metodologia",
        problem: "Herramental",
        reason: "Dado realiza corte profundo (106)",
        other_comment: null
    },
    'Prueba de ajedrez (107)': {
        location: "Horizon",
        category: "Metodologia",
        problem: "Set Up",
        reason: "Prueba de ajedrez (107)",
        other_comment: null
    },
    'Atoramiento feeder (200)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento feeder (200)",
        other_comment: null
    },
    'Atoramiento en conveyor belt (201)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en conveyor belt (201)",
        other_comment: null
    },
    'Atoramiento en unidad laser (202)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en unidad laser (202)",
        other_comment: null
    },
    'Atoramiento en stacker (203)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en stacker (203)",
        other_comment: null
    },
    'Corte incorrecto (204)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Software",
        reason: "Corte incorrecto (204)",
        other_comment: null
    },
    'Corte profundo (205)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Software",
        reason: "Corte profundo (205)",
        other_comment: null
    },
    'Corte descentrado / Skew (206)': {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Software",
        reason: "Corte descentrado / Skew (206)",
        other_comment: null
    },
    'Prueba de ajedrez (207)': {
        location: "SEI LASER",
        category: "Metodologia",
        problem: "Set Up",
        reason: "Prueba de ajedrez (207)",
        other_comment: null
    },
    'Hojas onduladas (1)': {
        location: "Kanban / Almacen",
        category: "Materiales",
        problem: "Material fuera de specificacion",
        reason: "Hojas onduladas (1)",
        other_comment: null
    },
    'Material defectuoso, Manchado, rayado, con pegamento (2)': {
        location: "Kanban / Almacen",
        category: "Materiales",
        problem: "Material con defecto de proveedor",
        reason: "Material defectuoso, Manchado, rayado, con pegamento (2)",
        other_comment: null
    },
    'Pruebas Ingenieria (3)': {
        location: "Pruebas ",
        category: "Pruebas",
        problem: "Pruebas Ingenieria",
        reason: "Pruebas Ingenieria (3)",
        other_comment: null
    },
    'Orden Cancelada (4)': {
        location: "Cliente",
        category: "Cliente",
        problem: "Cliente",
        reason: "Orden Cancelada (4)",
        other_comment: null
    },
    'Job Duplicado (5)': {
        location: "Proceso",
        category: "Metodologia",
        problem: "Produccion",
        reason: "Job Duplicado (5)",
        other_comment: null
    },
    'otro (especificar) (6)': {
        location: "otro",
        category: "otros",
        problem: "otro",
        reason: "otro (especificar) (6)",
        other_comment: null
    },
};


export const SCRAPREASONS = [
    {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en feeder (100)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en unidad de corte (101)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en stacker (102)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Maquinaria",
        problem: "Descentrado",
        reason: "Descentrado (103)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Metodologia",
        problem: "Herramental",
        reason: "Dado no corta (104)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Metodologia",
        problem: "Herramental",
        reason: "Dado equivocado (105)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Metodologia",
        problem: "Herramental",
        reason: "Dado realiza corte profundo (106)",
        other_comment: null
    },
    {
        location: "Horizon",
        category: "Metodologia",
        problem: "Set Up",
        reason: "Prueba de ajedrez (107)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento feeder (200)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en conveyor belt (201)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en unidad laser (202)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Atoramientos",
        reason: "Atoramiento en stacker (203)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Software",
        reason: "Corte incorrecto (204)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Software",
        reason: "Corte profundo (205)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Maquinaria",
        problem: "Software",
        reason: "Corte descentrado / Skew (206)",
        other_comment: null
    },
    {
        location: "SEI LASER",
        category: "Metodologia",
        problem: "Set Up",
        reason: "Prueba de ajedrez (207)",
        other_comment: null
    },
    {
        location: "Kanban / Almacen",
        category: "Materiales",
        problem: "Material fuera de specificacion",
        reason: "Hojas onduladas (1)",
        other_comment: null
    },
    {
        location: "Kanban / Almacen",
        category: "Materiales",
        problem: "Material con defecto de proveedor",
        reason: "Material defectuoso, Manchado, rayado, con pegamento (2)",
        other_comment: null
    },
    {
        location: "Pruebas ",
        category: "Pruebas",
        problem: "Pruebas Ingenieria",
        reason: "Pruebas Ingenieria (3)",
        other_comment: null
    },
    {
        location: "Cliente",
        category: "Cliente",
        problem: "Cliente",
        reason: "Orden Cancelada (4)",
        other_comment: null
    },
    {
        location: "Proceso",
        category: "Metodologia",
        problem: "Produccion",
        reason: "Job Duplicado (5)",
        other_comment: null
    },
    {
        location: "otro",
        category: "otros",
        problem: "otro",
        reason: "otro (especificar) (6)",
        other_comment: null
    },
]
/**
 * One laser configuration called "Laser", but they can specify which laser when inputting scrap
 * The reason is because we have no laser load balancing so Impreso cannot determine
 * which laser to designate batches to
 */
export const LASER_LIST = [
    "Laser 1",
    "Laser 2",
]


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/scrap-reasons.ts